import React from 'react';
import { AppHeader } from '@frontend/app/refresh-components/AppHeader';
import { useHistory } from 'react-router-dom';
import { TProject } from '../types';
import { CampaignTypeSectionV2 } from './sections/CampaignTypeSectionV2';
import { AboutSectionV2 } from './sections/AboutSectionV2';
import { CampaignVariantsSnapshot } from './components/CampaignVariantsSnapshot';
import { SaveCampaignCTA } from './components/SaveCampaignCTA';
import { useCampaign } from './CampaignContext';
import { PreviewCampaignSnapshot } from './components/PreviewCampaignSnapshot';

interface Props {
  mode?: 'add' | 'edit';
  project?: TProject;
  onSave?: () => void;
  refetchProjects?: () => void;
}

export const NewCampaignSetup: React.FC<Props> = ({
  mode = 'add',
  project,
  onSave,
  refetchProjects,
}) => {
  const { currentStep } = useCampaign();
  const history = useHistory();

  return (
    <>
      <AppHeader
        title="New Campaign"
        backButtonFunction={history.goBack}
      />
      <div className="flex h-screen bg-gray-50">
        {/* Left Section - Form */}
        <div className="w-full lg:w-[70%] h-full overflow-y-auto">
          <div className="flex flex-col gap-6 p-6 max-w-[800px] mx-auto">
            {/* Save Campaign CTA */}
            <SaveCampaignCTA
              mode={mode}
              project={project}
              onSave={onSave}
              refetchProjects={refetchProjects}
            />

            {/* Campaign Type Section (Accordion) */}
            <CampaignTypeSectionV2 />

            {/* About Section */}
            <AboutSectionV2 project={project} />
          </div>
        </div>

        {/* Right Section - Campaign Snapshot */}
        <div className="hidden lg:block lg:w-[30%] border-l border-grey-3 h-full overflow-y-auto">
          {currentStep === 1 && <CampaignVariantsSnapshot />}
          {currentStep === 2 && <PreviewCampaignSnapshot />}
        </div>
      </div>
    </>
  );
};
